<template>
  <div>
    <v-row dense>
      <v-btn small text link target="_blank" to="/cotacoes?filter=respondidas" color="primary">
        Ver respondidas
        <v-icon small>mdi-open-in-new</v-icon>
      </v-btn>
      <v-spacer/>
      <px-select-menu prepend-icon="mdi-sort-variant"
                      v-model="selectedSort"
                      :options="sortOptions"
                      @change="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
      <v-btn icon @click="emitChange">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-painel-cotacoes-filtros @change="emitChange">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </template>
      </px-painel-cotacoes-filtros>
    </px-line-filter>
  </div>
</template>

<script>
import PainelCotacoesFiltros from './PainelCotacoesFiltros.vue';

export default {
  props: {},
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  data() {
    return {
      sortOptions: [
        {
          description: 'Mais recentes',
          value: 'createdIn desc',
          desc: true,
        },
        {
          description: 'Mais antigas',
          value: 'createdIn',
          desc: false,
        },
      ],
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: ['NAO_RESPONDIDA'],
        },
        {
          id: 'MEUS_LOCAIS',
          description: 'Meus locais de coleta',
          value: ['RESPONDIDA'],
        },
      ],
    };
  },
  computed: {
    selectedStatus: {
      get() {
        return this.$store.getters['painelCotacao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('painelCotacao/selectedStatus', selectedStatus);
      },
    },
    selectedSort: {
      get() {
        return this.$store.getters['painelCotacao/selectedSort'];
      },
      set(selectedSort) {
        this.$store.dispatch('painelCotacao/selectedSort', selectedSort);
      },
    },
  },
  created() {
    if (!this.selectedSort) {
      [this.selectedSort] = this.sortOptions;
    }
  },
  components: {
    pxPainelCotacoesFiltros: PainelCotacoesFiltros,
  },
};
</script>
